import axios from "../config/axios";
import { NotificationApi } from "../Utils/Api";

export const NotificationService = {
  registerToken: async (data, userToken) => {
    return await axios.post(NotificationApi.RegisterToken, data, {
      headers: userToken ? { Authorization: `Bearer ${userToken}` } : {},
    });
  },
  removeToken: async (fcmToken, userToken) => {
    return await axios.post(
      NotificationApi.RemoveToken,
      { fcmToken },
      {
        headers: userToken ? { Authorization: `Bearer ${userToken}` } : {},
      },
    );
  },
  getMyNotifications: async () => {
    return await axios.get(NotificationApi.MyNotifications);
  },
  markRead: async (notificationId) => {
    return await axios.post(NotificationApi.MarkRead, { notificationId });
  },
};
